import { useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";
import { User } from "../../types/User";
import amplifyService from "./amplifyService";
import { storage } from "../../utils/storage";

const AuthProvider = ({ children }: { children: JSX.Element }) => {

    const [user, setUser] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        console.log("AuthProvider initializing...")
        const validateToken = async () => {
            setIsLoading(true);
            try {
                const result = await amplifyService.validateToken();
                if (result.user) {
                    setUser(result.user);
                    if (result.token) {
                        localStorage.setItem('authToken', result.token);
                    }
                    console.log('Token validated successfully');
                } else {
                    console.log('No valid token found');
                    setUser(null);
                }
            } catch (error) {
                console.log('Token validation failed:', error);
                localStorage.removeItem('authToken');
                setUser(null);
            } finally {
                setIsLoading(false);
            }
        }
        validateToken();
    }, []);

    const signin = async (username: string, password: string) => {
        const { user, token } = await amplifyService.signin(username, password);

        if (user && token) {
            setUser(user);
            localStorage.setItem('authToken', token);
            return true;
        }
        return false;
    }

    const signout = async () => {
        setUser(null);
        localStorage.removeItem('authToken');
        storage.clearAll();
        await amplifyService.signout();
    }

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-lg">Validando sessão...</div>
            </div>
        );
    }

    return (
        <AuthContext.Provider value={{ user, signin, signout }}>
            {children}
        </AuthContext.Provider>
    );

};

export default AuthProvider;
